import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Modal from 'react-native-modal';
import { useWindowDimensions, TextInput, KeyboardAvoidingView } from 'react-native';
import { Text, View } from '@constants/Themed';
import styles from '@stylesheet';
import Button from '../../UI/Button/Button';
import LottieView from '@utils/lottieAnimation';
import useGlobalUser from '@hooks/getGlobalUser';
import { BlurView } from "@react-native-community/blur";
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { set } from 'lodash';
import parseByDelimiter from '@utils/parseByDelimiter';

interface DeleteConfirmTypes {
  refreshFunction?: Function;
  deleteFunction?: Function;
  itemId?: string,
  itemS?: any
}

export interface DeleteConfirmModalHandle {
  openModal: (item: {}) => void;
}

const DataDeleteConfirmModal = forwardRef<DeleteConfirmModalHandle, DeleteConfirmTypes>((props, ref) => {
  const { deleteFunction, refreshFunction, itemId, itemS } = props;
  const windowDimensions = useWindowDimensions();
  const [confirmState, setConfirmState] = useState("");
  const globalUser = useGlobalUser();
  const [item, setItem] = useState({});
  const theme = themeSelector();
  const [visibleState, setState] = useState(false);
  const [refreshRequired, setRefreshRequired] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: (item) => {
      setItem(item);
      setState(true);
    }
  }));

  const handleDeleteFunction = async () => {
    if (deleteFunction) {
      const res = await deleteFunction(item._id);
      if (res.status === 204) {
        setState(false);
        setRefreshRequired(true);
      }
    }
  };

  return (
    <Modal
      isVisible={visibleState}
      animationIn={'zoomInDown'}
      animationOut={'zoomOutUp'}
      hasBackdrop={true}
      coverScreen={true}
      backdropColor="black"
      backdropOpacity={0.4}
      deviceHeight={windowDimensions.height}
      deviceWidth={windowDimensions.width}
      onBackdropPress={() => setState(false)}
      onModalHide={() => {
        setConfirmState("");
        if (refreshFunction && refreshRequired) {
          refreshFunction();
        }
      }}
      style={{ alignContent: 'center', alignItems: 'center', alignSelf: 'center' }}
    >
      <BlurView
        style={styles.blurViewStyle}
        blurType="light"
        blurAmount={10}
        reducedTransparencyFallbackColor="white"
        pointerEvents='none'
      />
      <View style={[styles.modalContainerAuth, { backgroundColor: theme ? "white" : "#333333", top: -20, alignItems: 'stretch', alignContent: 'space-around', width: '90%', minHeight: '85%', gap: 30, minWidth: 400, paddingHorizontal: 50 }]}>
        <KeyboardAvoidingView behavior='padding' keyboardVerticalOffset={180} style={{ flex: 1, paddingVertical: '10%' }}>
          <LottieView source={require('@assets/animations/animation_lk4gcmkh.json')} autoPlay style={{ flex: 1, minWidth: 100, maxHeight: 200, alignSelf: 'center' }} loop={false} />
          <View style={{ flex: 3, alignSelf: 'center', alignContent: 'space-around', alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{ textAlign: 'center' }}>Are you sure you want to delete <Text style={{ fontWeight: '600' }}>{parseByDelimiter(item?.dataTitle)}</Text>? {'\n'} {'\n'} This action cannot be undone</Text>
            <Text style={{ fontStyle: 'italic', textAlign: "center" }}>Type <Text style={{ fontWeight: 'bold' }}>'DELETE'</Text> below to confirm</Text>
            <TextInput value={confirmState} onChangeText={setConfirmState} style={[styles.inputOutline, { color: theme ? 'black' : 'white', fontWeight: '600', borderRadius: 40, textAlign: 'center' }]} />
          </View>
          <View style={{ flexDirection: 'row', gap: 30, flex: 1, maxHeight: 80 }}>
            <Button customStyle={{ flex: 1 }} textColor='white' onPress={() => setState(false)} buttonText={'Cancel'} />
            <Button customStyle={{ flex: 1 }} defaultColor='red' textColor='white' disabled={confirmState != 'DELETE'} onPress={handleDeleteFunction} buttonText={'DELETE'} />
          </View>
        </KeyboardAvoidingView>
      </View>
    </Modal>
  )
})

export default DataDeleteConfirmModal;
